{
	"DEFAULT": {
		"items": [
			{
				"href": "/",
				"testId": "services-menu",
				"icon": "home",
				"label": "Sidebar.Menu.Services"
			},
			{
				"href": "/pre-visit",
				"testId": "previsit-menu",
				"icon": "calendar-alt",
				"label": "Sidebar.Menu.PreVisit"
			},
			{
				"href": "/assigned-training-programs",
				"testId": "training-menu",
				"icon": "doc",
				"label": "Training.Menu.My_Training"
			},
			{
				"href": "/my-exercises",
				"testId": "toolkit-menu",
				"icon": "doc",
				"label": "Toolkit.Menu.My_Toolkit"
			},
			{
				"href": "/chats",
				"testId": "chats-menu",
				"icon": "chat",
				"label": "Sidebar.Title.Chats",
				"showUnreadMessages": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/wallet",
					"/consents",
					"/promo",
					"/bookings",
					"/bookings/upcoming",
					"/bookings/history",
					"/bookings/pre-visit"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "edit",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"isHiddenInMobile": false,
				"onClick": "editProfile"
			},
			{
				"href": "/bookings",
				"testId": "bookings-menu",
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings",
				"isHiddenInDesktop": true,
				"isHiddenInMobile": false
			},
			{
				"href": "/partners",
				"testId": "partners",
				"icon": "personal",
				"label": "Partners.Title",
				"isHiddenInMobile": false
			},
			{
				"href": "/bookings/upcoming",
				"testId": "upcoming-bookings",
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings",
				"isHiddenInMobile": true
			},
			{
				"href": "/insurance",
				"testId": "insurance",
				"icon": "virus-shield",
				"label": "Sidebar.Menu.Insurance",
				"isHiddenInMobile": false
			},
			{
				"href": "/wallet",
				"testId": "wallet",
				"icon": "transaction",
				"isHiddenInMobile": false,
				"label": "Profile.Menu.My_Transactions"
			},
			{
				"href": "/consents",
				"testId": "consents",
				"icon": "check",
				"isHiddenInMobile": false,
				"label": "Components.Header.Button.Manage_Consents"
			},
			{
				"href": "/symptom-check/introduction",
				"testId": "symptom-check",
				"icon": "doc",
				"label": "Symptom_Check.Check",
				"isHiddenInMobile": false
			},
			{
				"href": "/promo",
				"testId": "promo",
				"icon": "star",
				"isHiddenInMobile": false,
				"label": "Sidebar.Menu.Promo"
			},
			{
				"id": "toggleServiceProviderRole",
				"testId": "switch-role",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Switch_Role",
				"isHiddenInMobile": true,
				"onClick": "toggleServiceProviderRole"
			},
			{
				"id": "toggleAdminAssistantStatus",
				"testId": "toggle-admin-assistant",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Toggle_Admin_Assistant_Status",
				"isHiddenInMobile": true,
				"onClick": "toggleAdminAssistantStatus"
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"isHiddenInMobile": false,
				"onClick": "logout"
			}
		]
	},
	"DEFAULT_PREVISIT": {
		"items": [
			{
				"href": "/pre-visit",
				"testId": "previsit-menu",
				"icon": "home",
				"label": "Sidebar.Menu.Services"
			},
			{
				"href": "/bookings/pre-visit",
				"testId": "previsit-tickets-menu",
				"icon": "clock",
				"label": "Sidebar.Menu.My_Tickets",
				"children": [
					"/bookings/:type"
				]
			},
			{
				"href": "/chats",
				"testId": "chats-menu",
				"icon": "chat",
				"label": "Sidebar.Title.Chats",
				"showUnreadMessages": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/consents",
					"/bookings",
					"/bookings/upcoming",
					"/bookings/history",
					"/bookings/pre-visit"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "edit",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"isHiddenInMobile": false,
				"onClick": "editProfile"
			},
			{
				"href": "/bookings",
				"testId": "bookings-menu",
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings",
				"isHiddenInDesktop": true,
				"isHiddenInMobile": false
			},
			{
				"href": "/bookings/upcoming",
				"testId": "upcoming-bookings",
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings",
				"isHiddenInMobile": true
			},
			{
				"href": "/consents",
				"testId": "consents",
				"icon": "check",
				"isHiddenInMobile": false,
				"label": "Components.Header.Button.Manage_Consents"
			},
			{
				"href": "/symptom-check/introduction",
				"testId": "symptom-check",
				"icon": "doc",
				"label": "Symptom_Check.Check",
				"isHiddenInMobile": false
			},
			{
				"id": "toggleServiceProviderRole",
				"testId": "switch-role",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Switch_Role",
				"isHiddenInMobile": true,
				"onClick": "toggleServiceProviderRole"
			},
			{
				"id": "toggleAdminAssistantStatus",
				"testId": "toggle-admin-assistant",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Toggle_Admin_Assistant_Status",
				"isHiddenInMobile": true,
				"onClick": "toggleAdminAssistantStatus"
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"isHiddenInMobile": false,
				"onClick": "logout"
			}
		]
	},
	"DEFAULT_SIFFI": {
		"items": [
			{
				"href": "/",
				"testId": "services-menu",
				"icon": "home",
				"label": "Sidebar.Menu.Services"
			},
			{
				"href": "/bookings",
				"testId": "bookings-menu",
				"isHiddenInDesktop": true,
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings"
			},
			{
				"href": "/bookings/upcoming",
				"testId": "upcoming-bookings",
				"isHiddenInMobile": true,
				"icon": "clock",
				"label": "Profile.Menu.My_Bookings",
				"children": [
					"/bookings/:type"
				]
			},
			{
				"href": "/assigned-training-programs",
				"testId": "training-menu",
				"icon": "doc",
				"label": "Training.Menu.My_Training"
			},
			{
				"href": "/my-exercises",
				"testId": "toolkit-menu",
				"icon": "doc",
				"label": "Toolkit.Menu.My_Toolkit"
			},
			{
				"href": "/chats",
				"testId": "chats-menu",
				"icon": "chat",
				"label": "Sidebar.Title.Chats",
				"showUnreadMessages": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/wallet",
					"/consents"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "edit",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"isHiddenInMobile": false,
				"onClick": "editProfile"
			},
			{
				"href": "/mental-health-services",
				"testId": "mental-health-services",
				"icon": "star",
				"isHiddenInMobile": false,
				"label": "Profile.Menu.Mental_Health_Services"
			},
			{
				"href": "/wallet",
				"testId": "wallet",
				"icon": "transaction",
				"isHiddenInMobile": false,
				"label": "Profile.Menu.My_Transactions"
			},
			{
				"href": "/consents",
				"testId": "consents",
				"icon": "check",
				"isHiddenInMobile": false,
				"label": "Components.Header.Button.Manage_Consents"
			},
			{
				"id": "toggleServiceProviderRole",
				"testId": "switch-role",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Switch_Role",
				"isHiddenInMobile": true,
				"onClick": "toggleServiceProviderRole"
			},
			{
				"id": "toggleAdminAssistantStatus",
				"testId": "toggle-admin-assistant",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Toggle_Admin_Assistant_Status",
				"isHiddenInMobile": true,
				"onClick": "toggleAdminAssistantStatus"
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"isHiddenInMobile": false,
				"onClick": "logout"
			}
		]
	},
	"SERVICE_PROVIDER": {
		"items": [
			{
				"href": "/schedule",
				"testId": "schedule-menu",
				"icon": "calendar-alt",
				"label": "Profile.Menu.Schedule",
				"isHiddenInDesktop": true,
				"isInTabs": true,
				"children": [
					"/schedule/configure"
				]
			},
			{
				"href": "/bookings",
				"testId": "bookings-menu",
				"icon": "clock",
				"label": "Profile.Menu.Bookings",
				"showUnconfirmedBookings": true,
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/bookings/upcoming",
					"/bookings/unconfirmed",
					"/bookings/history",
					"/bookings/request",
					"/bookings/pre-visit",
					"/bookings/service-provider-pre-visit",
					"/booking/instant"
				]
			},
			{
				"href": "/bookings/:type",
				"testId": "bookings-tabs",
				"icon": "clock",
				"label": "Profile.Menu.Bookings",
				"showUnconfirmedBookings": true,
				"isHiddenInDesktop": true,
				"isHiddenInMobile": true,
				"isInTabs": true,
				"children": [
					"/bookings/unconfirmed",
					"/bookings/history",
					"/bookings/request",
					"/bookings/pre-visit",
					"/bookings/service-provider-pre-visit",
					"/bookings"
				]
			},
			{
				"href": "/chats",
				"testId": "chats-menu",
				"icon": "chat",
				"label": "Sidebar.Title.Chats",
				"isInTabs": true,
				"showUnreadMessages": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/toolkit",
				"testId": "toolkit-menu",
				"icon": "notes",
				"label": "Sidebar.Menu.Toolkit",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/pre-visit/record-ticket-for-person",
				"testId": "previsit-record-ticket",
				"icon": "chat",
				"label": "Sidebar.Title.Pre_Visit",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/bookings/instant",
				"testId": "instant-booking",
				"label": "Booking.Instant.Title",
				"isInTabs": true,
				"isHiddenInDesktop": true,
				"isHiddenInMobile": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/sp-settings",
					"/transactions"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "edit",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"onClick": "editProfile",
				"isHiddenInMobile": false
			},
			{
				"href": "/sp-settings",
				"testId": "service-settings",
				"icon": "edit",
				"label": "Components.Header.Button.Edit_Service",
				"isHiddenInMobile": false
			},
			{
				"href": "/sp-feedbacks",
				"testId": "feedbacks",
				"icon": "star",
				"isHiddenInMobile": false,
				"label": "Services.Other.Feedback_Clients"
			},
			{
				"href": "/transactions",
				"testId": "transactions",
				"icon": "credit-card",
				"label": "Profile.Menu.My_Transactions",
				"isHiddenInMobile": false
			},
			{
				"id": "toggleServiceProviderRole",
				"testId": "switch-role",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Switch_Role",
				"isHiddenInMobile": true,
				"onClick": "toggleServiceProviderRole"
			},
			{
				"id": "toggleAdminAssistantStatus",
				"testId": "toggle-admin-assistant",
				"href": "#",
				"icon": "personal",
				"label": "Components.Header.Button.Toggle_Admin_Assistant_Status",
				"isHiddenInMobile": true,
				"onClick": "toggleAdminAssistantStatus"
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"onClick": "logout",
				"isHiddenInMobile": false
			}
		]
	},
	"SERVICE_OWNER": {
		"items": [
			{
				"href": "/employees",
				"testId": "employees-menu",
				"icon": "personal",
				"label": "Profile.Menu.Employees",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/transactions",
				"testId": "transactions-menu",
				"icon": "credit-card",
				"label": "Profile.Menu.Transactions",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/invoices",
				"testId": "invoices-menu",
				"icon": "transaction",
				"label": "Invoices.Title",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/therapy-fund-wallets",
				"testId": "therapy-fund-wallets-menu",
				"icon": "transaction",
				"label": "TherapyFundWallet.Title",
				"isInTabs": true,
				"isHiddenInDesktop": true,
				"isHiddenInMobile": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/settings"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "user",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"onClick": "editProfile",
				"isHiddenInMobile": false
			},
			{
				"href": "/settings",
				"testId": "service-settings",
				"icon": "edit",
				"label": "Components.Header.Button.Edit_Service",
				"isHiddenInMobile": false
			},
			{
				"href": "/therapy-fund-wallets",
				"testId": "therapy-fund-wallets",
				"icon": "transaction",
				"label": "TherapyFundWallet.Title",
				"isHiddenInMobile": false
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"onClick": "logout",
				"isHiddenInMobile": false
			}
		]
	},
	"BUSINESS_CLIENT": {
		"items": [
			{
				"href": "/employees",
				"testId": "employees-menu",
				"icon": "personal",
				"label": "Profile.Menu.Employees",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/dashboard",
				"testId": "dashboard-menu",
				"icon": "pie",
				"label": "Profile.Menu.Dashboard",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/employee-surveys",
				"testId": "surveys-menu",
				"icon": "calendar-alt",
				"label": "Profile.Menu.Surveys",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/compliance",
				"icon": "star",
				"label": "Profile.Menu.Compliance",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/training-programs",
				"testId": "training-programs-menu",
				"icon": "pie",
				"label": "Training.Menu.Programs",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/join-requests",
				"testId": "join-requests-menu",
				"icon": "star",
				"label": "Profile.Menu.JoinRequests",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/limits",
				"testId": "limits-menu",
				"icon": "credit-card",
				"label": "Profile.Menu.Limits",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/invoices",
				"testId": "invoices-menu",
				"icon": "transaction",
				"label": "Invoices.Title",
				"isInTabs": true,
				"isHiddenInDesktop": true
			},
			{
				"href": "/profile",
				"testId": "profile-menu",
				"icon": "user",
				"isHiddenInDesktop": true,
				"isInTabs": false,
				"children": [
					"/settings"
				]
			}
		],
		"dropdownItems": [
			{
				"href": "#",
				"icon": "user",
				"testId": "edit-profile",
				"label": "Components.Header.Button.Edit_Profile",
				"onClick": "editProfile",
				"isHiddenInMobile": false
			},
			{
				"href": "/settings",
				"testId": "business-settings",
				"icon": "edit",
				"label": "Components.Header.Button.Edit_Business_Info",
				"isHiddenInMobile": false
			},
			{
				"href": "/transactions",
				"testId": "transactions",
				"icon": "credit-card",
				"label": "Profile.Menu.Transactions",
				"isHiddenInMobile": false
			},
			{
				"href": "/corporate-insurance",
				"testId": "corporate-insurance",
				"icon": "virus-shield",
				"label": "Insurance.Title",
				"isHiddenInMobile": false
			},
			{
				"href": "/dependents",
				"testId": "dependents",
				"icon": "personal",
				"label": "Profile.Menu.Dependents",
				"isHiddenInMobile": false
			},
			{
				"href": "#",
				"icon": "logout",
				"testId": "logout",
				"label": "Components.Header.Button.Log_Out",
				"onClick": "logout",
				"isHiddenInMobile": false
			}
		]
	}
}
